"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonLocale = void 0;
const commonLocale = exports.commonLocale = {
  yearFormat: 'YYYY',
  dayFormat: 'D',
  cellMeridiemFormat: 'A',
  monthBeforeYear: true
};